import { cn } from "@/lib/utils";

export type StatusKind = "live" | "estimated" | "unknown" | "sota" | "synced" | "running" | "ran";

const META: Record<
  StatusKind,
  { glyph: string; label: string; className: string; pulse?: boolean }
> = {
  live: { glyph: "●", label: "LIVE", className: "text-[color:var(--accent)]", pulse: true },
  synced: { glyph: "✸", label: "SYNCED", className: "text-[color:var(--accent)]" },
  running: { glyph: "●", label: "RUNNING", className: "text-[color:var(--accent)]", pulse: true },
  ran: { glyph: "✸", label: "RAN", className: "text-[color:var(--lime)]" },
  estimated: { glyph: "●", label: "ESTIMATED", className: "text-[color:var(--warn)]" },
  unknown: { glyph: "○", label: "UNKNOWN", className: "text-[color:var(--faint)]" },
  sota: { glyph: "◆", label: "SOTA", className: "text-[color:var(--accent)]" },
};

export function StatusDot({
  kind,
  label,
  className,
}: {
  kind: StatusKind;
  label?: string;
  className?: string;
}) {
  const m = META[kind];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 font-mono text-[0.65rem] font-medium uppercase tracking-[0.08em]",
        m.className,
        className,
      )}
    >
      <span className={cn(m.pulse && "status-pulse")} aria-hidden>
        {m.glyph}
      </span>
      {label ?? m.label}
    </span>
  );
}
